export default __webpack_public_path__ + "static/media/logo.d693b334.png";